<agr-dialog [data]="data" (confirm)="confirm($event)" (cancel)="cancel()">
  <agr-advisor-relationships-selector
    [relatedType]="relatedType"
    (selected)="confirm($event)"
    data-test="select-customer-dialog-selector"
  ></agr-advisor-relationships-selector>
</agr-dialog>
